import { Grid } from "designSystem/index";
import { SingleSelect } from "designSystem/index";
import React from "react";
import { items } from "designSystemLegacy/data";

export default () => {
	return (
		<Grid
			container
			direction="column"
			spacing={4}
		>
			<Grid item>
				<SingleSelect
					allowCustomOptions
					options={items}
					value={items[0]}
				/>
			</Grid>
		</Grid>
	);
};
